import { combineReducers } from 'redux';
import { i18nReducer } from 'react-redux-i18n';
import userReducer from './user/userReducer';

export default combineReducers({
  i18n: i18nReducer,
  user: userReducer,
});
